// This marker only selects a screen. It never authenticates or verifies an account.
const KEY = 'kelimoRecoveryReturnV202';
const MAX_AGE = 15 * 60 * 1000;
function pending(session, now) {
  try {
    const value = JSON.parse(session.getItem(KEY) || 'null');
    if (value && typeof value.username === 'string' && value.username &&
        Number.isFinite(value.expires) && value.expires > now && value.expires <= now + MAX_AGE) return value;
  } catch (_) { /* Ignore malformed navigation state. */ }
  session.removeItem(KEY);
  return null;
}
function prepareRecoveryReturn(location, history, session, local, forgetSession, now = Date.now()) {
  const params = new URLSearchParams(location.hash.slice(1));
  const target = params.get('account-return');
  if (!['login', 'recovery'].includes(target)) return;
  history.replaceState(null, '', location.pathname + location.search);
  const expected = params.get('account');
  if (target === 'recovery' && (!expected || expected.length > 100)) return;
  session.removeItem(KEY);
  if (target === 'login' || (session.getItem('username') && session.getItem('username') !== expected.toLowerCase())) {
    forgetSession(session, local);
    for (const key of ['username', 'reconnectToken', 'gameId', 'gameOverData']) session.removeItem(key);
  }
  if (target === 'recovery') session.setItem(KEY, JSON.stringify({username: expected.toLowerCase(), expires: now + MAX_AGE}));
  session.setItem('currentScreen', target === 'recovery' && session.getItem('reconnectToken') ? 'start' : 'login');
}
function consumeRecoveryReturn(session, username, now = Date.now()) {
  const value = pending(session, now);
  if (!value || value.username !== username.toLowerCase()) return false;
  session.removeItem(KEY);
  return true;
}
module.exports = { prepareRecoveryReturn, consumeRecoveryReturn };
